import {saveAs} from 'file-saver'
/***
 * @param data サーバ上から返してもらったCSV用データ
 */
export function downloadCsvData(filename, columns, data, qualifier){
	const rowData = makeCsvData(columns,data);
	const csvData = convertToCSV(rowData);
	
	//UTF-8用BOMを生成
	let bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
	let blob = new Blob([bom, csvData], {"type": "text/csv"});
	
	saveAs(blob,filename + ".csv")
}

export function convertToCSV(objArray,qualifier) {
	let array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
	let str = '';
	const quali = !(qualifier) ? '"' : '';
	for (let i = 0; i < array.length; i++) {
		let line = '';
		for (let index in array[i]) {
			if (line !== '') line += ',';
			const val = array[i][index] === undefined || array[i][index] === null ? "" : array[i][index];
			line += quali + val + quali;
			
			
		}
		str += line + '\r\n';
	}
	return str;
}

export function makeCsvData(columns,data){
	let returns = [];
	
	let push_row = [];
	columns.forEach(column=>{
		push_row.push(column.title);
	});
	returns.push(push_row);
	
	data.forEach(row=>{
		push_row = [];
		columns.forEach(column=>{
			push_row.push(row[column.name]);
		});
		returns.push(push_row);
	});
	
	return returns;
}

export function getFileExtension(filename)
{
	const ext = /^.+\.([^.]+)$/.exec(filename);
	return ext === null ? "" : ext[1];
}


// WEBPACK FOOTER //
// ./src/common/utils/download-csv.js